import React from "react";
import YellowDivider from "../../components/dividers/YellowDivider";
import GetStartedBanner from "../../components/ctabanner/GetStartedBanner";
import StartLearningNowBanner from "../../components/ctabanner/StartLearningNowBanner";
import AcademyCatalogue from "../../components/catalogue/AcademyCatalogue";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
const AcademyCataloguePage: React.FC = () => {
  const { t, ready } = useTranslation();
  return (
    <div className="main">
      <GetStartedBanner />
      <div className="container mt-4">
        <div className="mb-md-0 mb-lg-3">
          <h2>
            {" "}
            {ready ? (
              `${t("catalogue-filter.courses")}`
            ) : (
              <Skeleton width={200} />
            )}{" "}
          </h2>
          <YellowDivider heading="h2" />
        </div>
        <AcademyCatalogue />
      </div>
      <StartLearningNowBanner />
    </div>
  );
};

export default AcademyCataloguePage;
